import { Injectable } from '@angular/core';

import { AppConfig } from '../app.config';
import { throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { HelpersService } from './helpers.service';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import moment from 'moment';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback

@Injectable({
  providedIn: 'root',
})
export class RentalsService {
  private env: any;

  constructor(
    private http: HttpClient,
    private httpClient: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService,
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.env = this.appConfig.getEnvironmentNew();
  }

  //Rental Config
  getRentalConfiguration(partnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Configuration?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateRentalConfig(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/Bikeshop/Rentals/Configuration?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateRentalConfigDefaultStoreTimes(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Bikeshop/Rentals/Configuration/DefaultStoreTimes?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  //Rental store time override
  getOverrideStoreTimes(partnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/OverrideStoreTimes?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  addOverrideStoreTime(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Bikeshop/Rentals/Configuration/OverrideStoreTimes?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  deleteOverrideStoreTime(partnerID: number, timeSlotID: number) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .delete(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/OverrideTimeSlot/${timeSlotID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  //Rental custom pickup slot
  getOverridePickupSlots(partnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/OverridePickupSlots?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  addOverridePickupSlot(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Bikeshop/Rentals/Configuration/OverridePickupSlot?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  deleteOverridePickupSlot(partnerID: number, pickupSlotID: number) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .delete(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/OverridePickupSlot/${pickupSlotID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  //Product Categories
  getRentalProductCategories(partnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/ProductCategories?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  addRentalProductCategory(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/Bikeshop/Rentals/ProductCategory?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateRentalProductCategory(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url + `/Bikeshop/Rentals/ProductCategory?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  //Accessory Categories
  getRentalAccessoryCategories(partnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/AccessoryCategories?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  addRentalAccessoryCategory(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Bikeshop/Rentals/AccessoryCategory?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateRentalAccessoryCategory(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url +
        `/Bikeshop/Rentals/AccessoryCategory?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  //Products
  getRentalProducts(partnerID, page = 1, limit = 10, search = '') {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Products?page=${page}&limit=${limit}&search=${search}&code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getRentalProduct(partnerID, productID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Product/${productID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  addRentalProduct(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/Bikeshop/Rentals/Product?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateRentalProduct(partnerID, data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Product?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateRentalProductInline(partnerID, data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/ProductInline?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getActiveRentalProducts(partnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Reservations/ActiveProducts?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getAvailableRentalProducts(
    partnerID,
    fromDate,
    toDate,
    reservationID: number = 0,
    isDemo: boolean = false
  ) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Reservations/AvailableProducts?FromDate=${fromDate}&ToDate=${toDate}&ReservationID=${reservationID}&IsDemo=${isDemo}&code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getAvailableRentalAvailableProductsAccessories(
    partnerID,
    fromDate,
    toDate,
    reservationID: number = 0,
    isDemo: boolean = false,
  ) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Reservations/AvailableProductsAccessories?FromDate=${fromDate}&ToDate=${toDate}&ReservationID=${reservationID}&IsDemo=${isDemo}&code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getFirstAvailableServiceSlot(partnerID, currentTime) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Service/FirstAvailableSlot?CurrentTime=${currentTime}&code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  //Accessories
  getRentalAccessories(partnerID, page = 1, limit = 10, search = '') {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Accessories?page=${page}&limit=${limit}&search=${search}&code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getRentalAccessory(partnerID, accessoryID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Accessory/${accessoryID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  addRentalAccessory(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/Bikeshop/Rentals/Accessory?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateRentalAccessory(partnerID, data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Accessory?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateRentalAccessoryInline(partnerID, data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/AccessoryInline?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getActiveRentalAccessories(partnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Reservations/ActiveAccessories?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  //Media
  uploadRentalImage(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/Bikeshop/Rentals/Image?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  //Reservation

  getReservationCalendarData(partnerID, fromDate, toDate) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/V2/Bikeshop/${partnerID}/Rentals/Reservations/CalendarData?FromDate=${fromDate}&ToDate=${toDate}&code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getReservationCalendarOverrideStoreTimes(partnerID, fromDate, toDate) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Reservations/Calendar/OverrideStoreTimes?FromDate=${fromDate}&ToDate=${toDate}&code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getReservationsSummary(partnerID, fromDate, toDate, showAllActive = false, searchString = '') {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Reservations/Summary?FromDate=${fromDate}&ToDate=${toDate}&CurrentLocalTime=${moment(new Date()).format('YYYY-MM-DDTHH:mm:ss')}&ShowAllActive=${showAllActive}&SearchString=${searchString}&code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getReservationPrintSummary(reservationIdentifier) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/Rentals/Reservation/PrintSummary/${reservationIdentifier}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getRentalAvailability(partnerID, fromDate, toDate) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Availability?FromDate=${fromDate}&ToDate=${toDate}&CurrentLocalTime=${moment(new Date()).format('YYYY-MM-DDTHH:mm:ss')}&code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getRentalFlexibleAvailability(partnerID, fromDate, toDate) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/FlexibleAvailability?FromDate=${fromDate}&ToDate=${toDate}&CurrentLocalTime=${moment(new Date()).format('YYYY-MM-DDTHH:mm:ss')}&code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getRentalFlexibleReturnDates(partnerID, fromDate, toDate) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/FlexibleReturnDates?FromDate=${fromDate}&ToDate=${toDate}&CurrentLocalTime=${moment(new Date()).format('YYYY-MM-DDTHH:mm:ss')}&code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  createRentalReservation(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/V2/Bikeshop/Rentals/Reservation?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getRentalReservation(partnerID, reservationID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Reservation/${reservationID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getRentalReservationPaymentHistory(partnerID, reservationID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Reservation/${reservationID}/PaymentHistory?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateReservation(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url + `/Bikeshop/Rentals/Reservation?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateReservationProducts(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url +
        `/V3/Bikeshop/Rentals/Reservation/Products?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateReservationStatus(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url +
        `/Bikeshop/Rentals/Reservation/Status?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateReservationStoreNotes(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url +
        `/Bikeshop/Rentals/Reservation/StoreNotes?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  //Reservation Invoice
  getRentalReservationInvoice(reservationID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/Rentals/Reservation/Invoice/${reservationID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  addRentalReservationInvoiceLineItem(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Bikeshop/Rentals/Reservation/InvoiceLineItem?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateRentalReservationInvoiceLineItem(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url +
        `/Bikeshop/Rentals/Reservation/InvoiceLineItem?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  deleteRentalReservationInvoiceLineItem(lineItemID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .delete(
        this.env.url +
        `/Bikeshop/Rentals/Reservation/InvoiceLineItem/${lineItemID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  sendInvoiceToPOS(reservationID, invoiceID) {
    if (this.helpersService.getPartnerData().POSSystemID <= 10) {
      const headers = this.helpersService.getNewApiHeaders();
      var data = { ReservationID: reservationID };
      return this.http
        .post(
          this.env.url +
          `/Bikeshop/Rentals/Reservation/SendToPOS?code=${this.env.key}`,
          data,
          headers,
        )
        .pipe(
          map((res: any) => {
            return res;
          }),
          catchError((res: Response) => {
            this.errorHandler.showError(
              res,
              'Failed to send the invoice to your POS',
            );
            return throwError(res.json());
          }),
        );
    } else {
      var headers = this.helpersService.getPOSApiHeaders(
        this.appConfig.getPOSEnvironment().key,
      );
      return this.http
        .post(
          this.appConfig.getPOSEnvironment().url +
          `/${this.helpersService.getPartnerId()}/rentals/invoices/${invoiceID}`,
          null,
          headers,
        )
        .pipe(
          map((res: any) => {
            return res;
          }),
          catchError((res: Response) => {
            this.errorHandler.showError(
              res,
              'Failed to send the invoice to your POS',
            );
            return throwError(res);
          }),
        );
    }
  }

  getRentalReservationMessages(partnerID, reservationID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/ReservationMessages/${reservationID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  postRentalReservationMessage(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Bikeshop/Rentals/ReservationMessage?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  postRentalReservationAttachment(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Bikeshop/Rentals/Reservation/Attachment?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getRentalReservationAttachments(partnerID, reservationID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Reservation/${reservationID}/Attachments?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  deleteRentalReservationAttachment(partnerID, reservationID, attachmentID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .delete(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Reservation/${reservationID}/Attachment/${attachmentID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getRentalReservationWaiver(partnerID, reservationID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Reservation/${reservationID}/Waiver?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  createReservationWaiver(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Bikeshop/Rentals/Reservation/Waiver?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  resendReservationWaiver(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Bikeshop/Rentals/Reservation/ResendWaiver?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  searchReservations(partnerID, searchData: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Reservation/Search?code=${this.env.key}`,
        searchData,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  //Billing and pricing
  getRentalPriceGroups(partnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/PriceGroups?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  addRentalPriceGroup(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/Bikeshop/Rentals/PriceGroups?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateRentalPriceGroup(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url + `/Bikeshop/Rentals/PriceGroups?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  addRentalFlexiblePriceGroup(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Bikeshop/Rentals/Flexible/PriceGroups?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateRentalFlexiblePriceGroup(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url +
        `/Bikeshop/Rentals/Flexible/PriceGroups?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getRentalAllowableTimeUnits(partnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/TimeUnits?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  addRentalAllowableTimeUnit(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/Bikeshop/Rentals/TimeUnits?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateRentalAllowableTimeUnit(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url + `/Bikeshop/Rentals/TimeUnits?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getRentalPriceGroupsDetail(partnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/PriceGroups/Detail?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getRentalFixedPriceGroupsDetail(partnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/FixedPriceGroups/Detail?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getRentalFlexibleConfiguration(partnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Flexible/Configuration?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateRentalFlexibleConfiguration(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Bikeshop/Rentals/Flexible/Configuration?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getRentalFlexibleTimeUnits(partnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/FlexibleTimeUnits?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  addRentalFlexibleTimeUnits(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Bikeshop/Rentals/FlexibleTimeUnits?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateRentalFlexibleTimeUnits(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url +
        `/Bikeshop/Rentals/FlexibleTimeUnits?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getRentalFlexiblePriceGroupsDetail(partnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/FlexiblePriceGroups/Detail?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  addRentalAllowableTimeUnits(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/Bikeshop/Rentals/TimeUnits?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getRentalAccessoryProductLink(partnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/ProductAccessoryLink?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  addRentalAccessoryProductLink(partnerID, data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/ProductAccessoryLink?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  deleteRentalAccessoryProductLink(partnerID, data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/ProductAccessoryLink?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getRentalReportList() {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url + `/Bikeshop/Rentals/ReportList?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getRentalReport(partnerID, reportID, startDate, endDate) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Report/${reportID}?startDate=${startDate}&endDate=${endDate}&code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getRentalCustomQuestions(partnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Configuration/CustomQuestions?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateRentalCustomQuestion(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Bikeshop/Rentals/Configuration/CustomQuestions?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  deleteRentalCustomQuestion(partnerID, customQuestionID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .delete(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/CustomQuestion/${customQuestionID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getRentalReservationSecurityDepositInfo(partnerID, reservationID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Reservation/${reservationID}/SecurityDepositInformation?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  postSecurityDepositAuthorize(partnerID, reservationID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Reservation/${reservationID}/SecurityDeposit/Authorize?code=${this.env.key}`,
        null,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  postSecurityDepositCancel(partnerID, reservationID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Reservation/${reservationID}/SecurityDeposit/CancelAuthorization?code=${this.env.key}`,
        null,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  postSecurityDepositRelease(partnerID, reservationID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Reservation/${reservationID}/SecurityDeposit/ReleaseAuthorization?code=${this.env.key}`,
        null,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  postSecurityDepositCapture(partnerID, reservationID, data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Reservation/${reservationID}/SecurityDeposit/Capture?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateReservationPaymentStatus(reservationID) {
    const data = { ID: reservationID };
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url +
        `/Bikeshop/Rentals/Reservation/PaymentStatus?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  //Rental Slpit Payment Config
  getRentalSplitPaymentConfiguration(partnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/SplitPaymentConfiguration?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateRentalSplitPaymentConfiguration(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url +
        `/Bikeshop/Rentals/SplitPaymentConfiguration?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getRentalReservationLongTermPaymentSchedule(partnerID, reservationID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Reservation/${reservationID}/LongTermPaymentSchedule?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  retryProcessRentalsRecuringPayment(partnerID, paymentScheduleID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/ProcessRentalsRecuringPayments/Retry/${paymentScheduleID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getRentalAffiliates(partnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Affiliates?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getRentalAffiliate(partnerID, affiliateID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Affiliate/${affiliateID}/Configuration?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  createRentalAffiliate(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Bikeshop/Rentals/Affiliate/Configuration?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateRentalAffiliate(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url +
        `/Bikeshop/Rentals/Affiliate/Configuration?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getRentalAffiliatesBooking(partnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Affiliates/Active?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateReservationAffiliate(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url +
        `/Bikeshop/Rentals/Reservation/Affiliate?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getRentalAffiliatesCommissionPayments(
    partnerID: number,
    selectedAffiliates: any,
    startDate: string,
    endDate: string,
  ) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/AffiliateCommissionReport?code=${this.env.key}&affiliates=${selectedAffiliates}&startDate=${startDate}&endDate=${endDate}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateAffiliatePaymentMarkPaid(partnerID, affiliateID, affiliatePaymentID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Affiliate/${affiliateID}/Payment/${affiliatePaymentID}/MarkPaid?code=${this.env.key}`,
        {},
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  importRentalProducts(partnerID, data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Products/Import?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: Response) => {
          return throwError(res.json());
        }),
      );
  }

  getRentalProductMoveData(
    partnerID: number,
    productID: number,
    localDateTime: string,
  ) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Product/${productID}/CanMove?code=${this.env.key}&localDateTime=${localDateTime}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: Response) => {
          return throwError(res.json());
        }),
      );
  }

  moveRentalProduct(moveData: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/Bikeshop/Rentals/Product/Move?code=${this.env.key}`,
        moveData,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: Response) => {
          return throwError(res.json());
        }),
      );
  }

  addPaymentSchedule(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/Bikeshop/Rentals/Reservation/PaymentSchedule?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updatePaymentSchedule(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url + `/Bikeshop/Rentals/Reservation/PaymentSchedule?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  validateCouponCode(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/Rental/Coupon/Validation/Portal?code=${this.env.key}`,
        data,
        headers,
      );
  }

  updateCouponCode(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url + `/Bikeshop/Rentals/Reservation/CouponCode?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: Response) => {
          return throwError(res.json());
        }),
      );
  }

  getRentalProductBlocks(partnerID: number, productID: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Product/${productID}/Blocks?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  createRentalProductBlock(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/Bikeshop/Rentals/Product/Block?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: Response) => {
          return throwError(res.json());
        }),
      );
  }

  updateRentalProductBlock(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url + `/Bikeshop/Rentals/Product/Block?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: Response) => {
          return throwError(res.json());
        }),
      );
  }

  deleteRentalProductBlock(partnerID: number, productID: any, blockID: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .delete(
        this.env.url +
        `/Bikeshop/${partnerID}/Rentals/Product/${productID}/Blocks/${blockID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getAvailableDeliveryCollectionDates(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/Rentals/Deliveries/AvailableDeliveryCollectionDates?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  refundStripePayment(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Rental/StripePayment/Refund?code=${this.env.key}`, data, headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: Response) => {
          return throwError(res.json());
        }),
      );
  }

  updateRentalReservationAddress(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url + `/Bikeshop/Rentals/Reservation/UpdateAddress?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: Response) => {
          return throwError(res.json());
        }),
      );
  }

  getRenalServiceIndicators(partnerID: number) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http.get(this.env.url + `/Bikeshop/${partnerID}/Rentals/Configuration/ServiceIndicators?code=${this.env.key}`,
      headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateRenalServiceIndicator(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http.post(this.env.url + `/Bikeshop/Rentals/Configuration/ServiceIndicator?code=${this.env.key}`,
      data,
      headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getProductCategoriesLinkedToServiceIndicators(partnerID: number, serviceIndicatorID: number) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http.get(this.env.url + `/Bikeshop/${partnerID}/Rentals/Configuration/ProductCategoriesLinkedToServiceIndicator/${serviceIndicatorID}?code=${this.env.key}`,
      headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getServiceIndicatorStatusReport(partnerID: number) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http.get(this.env.url + `/Bikeshop/${partnerID}/Rentals/ServiceIndicatorStatusReport?code=${this.env.key}`,
      headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }
  
  getServiceIndicatorDueForServiceCount(partnerID: number) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http.get(this.env.url + `/Bikeshop/${partnerID}/Rentals/ServiceIndicator/ServiceDue/Count?code=${this.env.key}`,
      headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getRentalProductServiceIndicatorConfig(partnerID: number, productID: number) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http.get(this.env.url + `/Bikeshop/${partnerID}/Rentals/Product/${productID}/ServiceIndicatorConfig?code=${this.env.key}`,
      headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  linkProductToServiceIdicator(partnerID: number, productID: number, serviceIndicatorID: number) {
    const headers = this.helpersService.getNewApiHeaders();
    var data = {
      ProductID: productID,
      ServiceIndicatorID: serviceIndicatorID,
      DefaultPartnerID: partnerID
    }

    return this.http.post(this.env.url + `/Bikeshop/Rentals/ProductServiceIndicatorLink?code=${this.env.key}`,
      data,
      headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getRentalProductServiceIndicatorHistory(partnerID: number, productID: number) {
    const headers = this.helpersService.getNewApiHeaders();

    return this.http.get(this.env.url + `/Bikeshop/${partnerID}/Rentals/Product/${productID}/ServiceIndicatorHistory?code=${this.env.key}`,
      headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  addServiceIndicatorProductPoints(data: any) {
    const headers = this.helpersService.getNewApiHeaders();

    return this.http.post(this.env.url + `/Bikeshop/Rentals/ServiceIndicator/Product/AllocateManualPoints?code=${this.env.key}`,
      data,
      headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }
  
  addServiceIndicatorProductServiceEvent(data: any) {
    const headers = this.helpersService.getNewApiHeaders();

    return this.http.post(this.env.url + `/Bikeshop/Rentals/ServiceIndicator/Product/AllocateManualServiceEvent?code=${this.env.key}`,
      data,
      headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }
  
  getRentalReservationServiceIndicators(partnerID: number, reservationID: number) {
    const headers = this.helpersService.getNewApiHeaders();

    return this.http.get(this.env.url + `/Bikeshop/${partnerID}/Rentals/Reservation/${reservationID}/ServiceIndicators?code=${this.env.key}`,
      headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }
  
  captureServiceIndicatorValue(data: any) {
    const headers = this.helpersService.getNewApiHeaders();

    return this.http.post(this.env.url + `/Bikeshop/Rentals/Reservation/Product/AddServiceIndicatorValue?code=${this.env.key}`,
      data,
      headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }
  
  linkServiceEventToWorkShopService(data: any) {
    const headers = this.helpersService.getNewApiHeaders();

    return this.http.post(this.env.url + `/Bikeshop/Rentals/LinkServiceIndicatorServiceEventToWorkshopService?code=${this.env.key}`,
      data,
      headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

}
